module.exports = __webpack_public_path__ + "img/saotomeandprince.617a7974.svg";